import emitterEvents from "./emitterEvents";
import get from "lodash/get";

import commonConfig from "../config/common";

const {
  globalKeys: { eventBusKey }
} = commonConfig;

export const emit = async (action, store) => {
  if (action && Object.keys(emitterEvents).includes(action.type)) {
    get(window, eventBusKey).emit(
      ...(await emitterEvents[action.type](action, store.getState()))
    );
  }
};
